var host = globalThis.OpenLeaf;
var ns = host && host.__runtime && host.__runtime["@openleaf-editor/plugins-import"];
if (!ns) throw new Error("openleaf: @openleaf-editor/plugins-import is not on the host runtime. Load openleaf.min.js before this bundle.");
module.exports = ns;
